/// <amd-module name="Artifacts/Maven/components/MavenInstallTabInstructions" />
import { CopyableTextField } from "Artifacts/Root/protocols/components/CopyableTextField";
import * as React from "react";
import { Tab, TabBar, TabSize } from "VSSUI/Tabs";

export interface IMavenInstallTabInstructionProps {
  mavenCommand: string;
  gradleCommand: string;
}

export const MavenInstallTabInstructions: React.FC<IMavenInstallTabInstructionProps> = ({
  mavenCommand,
  gradleCommand,
}) => {
  const [selectedTabId, setSelectedTabId] = React.useState<string>("Maven");

  return (
    <React.Fragment>
      <div className="flex-column">
        <TabBar
          onSelectedTabChanged={setSelectedTabId}
          selectedTabId={selectedTabId}
          tabSize={TabSize.Compact}
        >
          <Tab name="Maven" id={"Maven"} />
          <Tab name={"Gradle"} id={"Gradle"} />
        </TabBar>

        {selectedTabId === "Maven" && (
          <React.Fragment>
            <CopyableTextField text={mavenCommand} />
          </React.Fragment>
        )}

        {selectedTabId === "Gradle" && (
          <React.Fragment>
            <CopyableTextField text={gradleCommand} />
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};
